import React, { useEffect, useRef, useState } from "react";
import useMediaQueries from "hooks/useMediaQueries.js";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Login from "components/Structure/Login/Login.js";
import Image from "components/Elements/Image/Image.tsx";
import Signup from "components/Structure/Signup/Signup.js";
import useShowManageContactsModal from "../hooks/useShowManageContactsModal.ts";
import useContactCircleModalPosition from "../hooks/useContactCircleModalPosition.ts";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./modalTooltip.scss";

const ManageContactsFooter = () => {
  const { getTextByKey } = useContent();
  return (
    <div className="tooltip-modal-footer manage-contacts">
      <Button>
        <LinkToNewTab isNewTab={true} page="user/contacts/contacts-list">
          {getTextByKey("manage-contacts-button")}
        </LinkToNewTab>
      </Button>
    </div>
  );
};

const TooltipModalFooter = () => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const handleClick = () => {
    setModal({
      modal: Login,
      modalSize: "full-modal",
    });
  };
  return (
    <div className="tooltip-modal-footer">
      {getTextByKey("manage-contacts-text")}
      <button onClick={handleClick} className="text-button">
        {getTextByKey("login")}
      </button>
    </div>
  );
};

export const ManageContactsToolltipModal = ({
  targetRef,
  isManageContacts,
  isCallToSignup,
}) => {
  const { closeModal, setModal } = useModal();
  const { getTextByKey } = useContent();
  const { setLastClosingTime } = useShowManageContactsModal();

  const modalWindowRef = useRef(null);

  const { cords, arrowStyle } = useContactCircleModalPosition({
    targetRef,
    modalWindowRef,
  });

  const handleClose = () => {
    closeModal();
    setLastClosingTime(Date.now());
  };

  return (
    <div
      className={`tooltip-modal${
        isManageContacts || isCallToSignup ? " manage-contacts" : ""
      }`}
      style={cords}
      ref={modalWindowRef}
      id={isCallToSignup ? "contacts-tooltip-modal" : ""}
    >
      <Button
        onClick={isCallToSignup ? handleClose : closeModal}
        className="close-button"
      >
        <Icon name="x" white />
      </Button>
      <div className="tooltip-modal-header">
        <Image name="home/send_contact" ext="png" />
      </div>
      <div className="tooltip-modal-content">
        <div className="tooltip-modal-content-title">
          {getTextByKey(
            isCallToSignup
              ? "tooltip-modal-signup-title"
              : "tooltip-modal-title"
          )}
        </div>
        <div className="tooltip-modal-content-text">
          {getTextByKey(
            isCallToSignup ? "tooltip-modal-signup-text" : "tooltip-modal-text"
          )}
        </div>
      </div>
      {isCallToSignup ? (
        <div className="tooltip-modal-footer manage-contacts">
          <Button
            onClick={() => {
              setModal({
                modal: Signup,
                modalSize: "full-modal",
              });
            }}
          >
            {getTextByKey("tooltip-modal-signup-button")}
          </Button>
        </div>
      ) : isManageContacts ? (
        <ManageContactsFooter />
      ) : (
        <TooltipModalFooter />
      )}
      <div className="tooltip-arrow" style={arrowStyle} />
    </div>
  );
};
